import { render, staticRenderFns } from "./number.vue?vue&type=template&id=ae405fae&scoped=true&"
import script from "./number.vue?vue&type=script&lang=js&"
export * from "./number.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae405fae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae405fae')) {
      api.createRecord('ae405fae', component.options)
    } else {
      api.reload('ae405fae', component.options)
    }
    module.hot.accept("./number.vue?vue&type=template&id=ae405fae&scoped=true&", function () {
      api.rerender('ae405fae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGen/FormDesign/ItemConfig/number.vue"
export default component.exports